import { createAsyncThunk } from "@reduxjs/toolkit";
import { checkCompletingReferences } from "toolkit/references/references.thunks";
import { OkvedSectionInterface } from "./codes.types";
import { directoryAPI } from "libs/apiClient/Directory";
import { snackWrapper } from "helpers";

export const getCodes = createAsyncThunk<OkvedSectionInterface[], { search: string; organizationId?: string }>(
	"codesSlice/getCodes",
	async (body, { rejectWithValue, dispatch }) => {
		try {
			const res = await directoryAPI
				.okvedListList({
					num: 203000,
					page: 1,
					query: body.search,
					organization: body.organizationId ? +body.organizationId : undefined,
				})
				.then((r) => r.data);
			dispatch(checkCompletingReferences());

			return res;
		} catch ({ message }) {
			return rejectWithValue(message);
		}
	},
);

export const getSections = createAsyncThunk<Omit<OkvedSectionInterface, "codes">[]>(
	"codesSlice/getSections",
	async (_, { rejectWithValue }) => {
		try {
			return await directoryAPI.okvedSectionListList().then((r) => r.data);
		} catch ({ message }) {
			return rejectWithValue(message);
		}
	},
);

export const addCode = createAsyncThunk(
	"codesSlice/addCode",
	async (
		body: {
			sectionCode: string;
			code: string;
			name: string;
			description: string;
		},
		{ rejectWithValue, dispatch },
	) => {
		try {
			const result = await directoryAPI.okvedCreate(body).then((r) => r.data);

			snackWrapper("success", "Код успешно добавлен");

			dispatch(getCodes({ search: "" }));
			dispatch(getSections());

			return result;
		} catch ({ message }) {
			snackWrapper("error", "Не удалось добавить код");

			return rejectWithValue(message);
		}
	},
);

export const editCode = createAsyncThunk(
	"codesSlice/editCode",
	async (body: { isMain: boolean | undefined; inputValues: any; code?: string }, { rejectWithValue, dispatch }) => {
		try {
			const bodyValues = body.code || body.inputValues.code;

			let result;

			if (body.isMain) {
				result = directoryAPI
					.okvedSectionUpdate(bodyValues, {
						code: body.inputValues.sectionCode,
						description: body.inputValues.description,
						name: body.inputValues.name,
					})
					.then((r) => r.data);
			} else {
				result = directoryAPI.okvedSectionUpdate(bodyValues, body.inputValues).then((r) => r.data);
			}

			snackWrapper("success", "Редактирование прошло успешно");

			dispatch(getCodes({ search: "" }));
			dispatch(getSections());

			return result;
		} catch ({ message }) {
			snackWrapper("error", "Редактирование не удалось");
			return rejectWithValue(message);
		}
	},
);

export const deleteCode = createAsyncThunk<string, string>(
	"codesSlice/deleteCode",
	async (code, { rejectWithValue, dispatch }) => {
		try {
			await directoryAPI.okvedDelete(code);
			snackWrapper("success", "Удаление прошло успешно");
			dispatch(getCodes({ search: "" }));
			dispatch(getSections());

			return code;
		} catch ({ message }) {
			dispatch(setCode({ code, delete: true }));

			return rejectWithValue(message);
		}
	},
);

export const setCode = createAsyncThunk(
	"codesSlice/setError",
	async (
		code: {
			code: string;
			delete: boolean;
		},
		{ rejectWithValue },
	) => {
		try {
			return code;
		} catch ({ message }) {
			return rejectWithValue(message);
		}
	},
);
